<script>
import { Line } from "vue-chartjs";
import moment from "moment";

export default {
    extends: Line,
    props: {
        serial: "",
        deviceID: '',
        period: {
            type: String,
            default: "D",
        },
    },
    data() {
        return {
            times: [],
            conn: [],
            ip: [],
            disconn: [],
            data: "",
        };
    },
    methods: {
        getData() {
            this.gradient = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 100);
            this.gradient2 = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 100);

            this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
            this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
            this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

            this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
            this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
            this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

            // let uri = `/api/devices/${this.$route.params.id}/data?type=connects&serial=${this.serial}&period=${this.period}`;
            let uri = `/api/devices/${this.deviceID}/data?type=connects&serial=${this.serial}&period=${this.period}`;
            axios
                .get(uri)
                .then((response) => {
                    this.data = response.data.data;
                    if (this.data) {
                        let i = 0;
                        this.data.forEach((row) => {
                            this.times.push(
                                moment.utc(row.t).local().format("YYYY-MM-DD HH:mm:ss")
                            );
                            if (row.ev == 1) {
                                this.conn.push(1);
                                this.disconn.push(0);
                                this.ip.push(row.ip);

                                if (i == this.data.length - 1) {
                                    this.times.push(moment.utc().local().format("YYYY-MM-DD HH:mm:ss"));
                                    this.conn.push(1);
                                    this.disconn.push(0);
                                    this.ip.push(row.ip);
                                }
                            } else {
                                this.conn.push(0);
                                this.disconn.push(1);
                                this.ip.push(this.ip[this.ip.length - 1]);

                                if (i == this.data.length - 1) {
                                    this.times.push(moment.utc().local().format("YYYY-MM-DD HH:mm:ss"));
                                    this.conn.push(0);
                                    this.disconn.push(1);
                                    this.ip.push(this.ip[this.ip.length - 1]);
                                }
                            }
                            i++;
                        });

                        this.renderChart({
                            labels: this.times,

                            datasets: [{
                                    label: "Disconnected",
                                    borderColor: "#FC2525",
                                    pointBackgroundColor: "white",
                                    borderWidth: 1,
                                    pointBorderColor: "white",
                                    pointRadius: 1,
                                    pointHoverRadius: 1,
                                    backgroundColor: this.gradient,
                                    data: this.disconn,
                                    steppedLine: true,
                                },
                                {
                                    label: "Connected",
                                    borderColor: "#05CBE1",
                                    pointBackgroundColor: "white",
                                    pointRadius: 1,
                                    pointHoverRadius: 1,
                                    pointBorderColor: "white",
                                    borderWidth: 1,
                                    backgroundColor: this.gradient2,
                                    data: this.conn,
                                    steppedLine: true,
                                },

                                {
                                    label: false,
                                    data: this.ip,

                                },

                            ],
                        }, {
                            responsive: true,
                            maintainAspectRatio: false,

                            legend: {
                                labels: {
                                    filter: function (item, chart) { // only show these 2
                                        return item.text === "Connected" || item.text === "Disconnected";
                                    }
                                }
                            },
                            scales: {
                                xAxes: [{
                                    type: "time",
                                    distribution: "linear",
                                    time: {
                                        displayFormats: {
                                            quarter: "MMM YYYY",
                                        },

                                        // parser: function(value) {
                                        // return moment.unix(value).local();
                                        // }
                                    },
                                    gridLines: {
                                        display: false,
                                    },

                                    scaleLabel: {
                                        display: false,
                                        labelString: "Time",
                                        fontColor: "#05CBE1",
                                    },
                                }, ],
                                yAxes: [{
                                    gridLines: {
                                        display: false,
                                    },
                                    ticks: {
                                        display: false,
                                    },
                                    scaleLabel: {
                                        display: false,
                                        labelString: "",
                                        fontColor: "#05CBE1",
                                    },
                                }, ],
                            },

                            tooltips: {

                                // enabled: true,
                                position: 'average',
                                // mode: 'index',
                                mode: 'label',
                                intersect: false,
                                filter: function (tooltipItem, data) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label;
                                    return ((label == "Disconnected") ? false : true);
                                },
                                callbacks: {
                                    // title: function (tooltipItems, data) {// don't want the timestamp
                                    //     return ' ';
                                    // },
                                    label: function (tooltipItem, data) {
                                        return data.datasets[2].data[tooltipItem.index];
                                    }
                                }
                            }

                        });
                    } else {
                        console.log("NO DATA");
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        // console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        // console.log('Error', error.message);
                    }
                    // console.log(error.config);
                });
        },
    },

    mounted() {
        this.getData();
        //     setInterval(() => {
        //   this.getData()
        // },  10000)
    },
    beforeDestroy() {
        if (this.times) this.rx_times = null;
        if (this.conn) this.conn = null;
        if (this.disconn) this.disconn = null;

        if (this.chart) {
            this.chart.destroy();
        }
    },
};
</script>
